import { isRecord } from '@/utils/filter/isRecord';
import { getLocalFilterValues } from '@/utils/filter/localFilterValues';

/**
 * Checks whether a local filter module contains at least one non-empty
 * filter value (multi-select array or single-select string). Handles both
 * flat (`{ filterKey: [...] }`) and channel-nested (`{ channel: { filterKey: [...] } }`) structures.
 */
export const isNonEmptyFilterModule = (value: unknown): boolean => {
  if (typeof value !== 'object' || value === null) return false;
  return Object.values(value).some(filterEntry => {
    if (getLocalFilterValues(filterEntry).length > 0) return true;
    if (isRecord(filterEntry)) {
      return Object.values(filterEntry).some(nested => getLocalFilterValues(nested).length > 0);
    }
    return false;
  });
};
